var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.45703 3.5C10.9068 3.5 12.082 4.67525 12.082 6.125C12.082 7.57475 10.9068 8.75 9.45703 8.75C8.00728 8.75 6.83203 7.57475 6.83203 6.125C6.83203 4.67525 8.00728 3.5 9.45703 3.5Z",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5076 10.917C12.3538 10.917 12.2011 10.9413 12.0549 10.989L11.3337 11.2246C10.1151 11.6224 8.80158 11.6224 7.58299 11.2246L6.86173 10.989C6.71558 10.9413 6.5628 10.917 6.40906 10.917H6.125C4.39911 10.917 3 12.3161 3 14.042V15.0322C3 15.6599 3.4549 16.1951 4.07439 16.2962C5.70596 16.5626 7.35235 16.7071 9 16.7297",
    stroke: "black",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 15.4602V17H12.5399L16.7239 12.816L16.7242 12.8157C16.8765 12.6634 16.9526 12.5873 16.9812 12.4995C17.0063 12.4222 17.0063 12.3389 16.9812 12.2616C16.9526 12.1737 16.8763 12.0974 16.7239 11.9449L16.0541 11.2752C15.9023 11.1234 15.8263 11.0473 15.7386 11.0188C15.6612 10.9937 15.578 10.9937 15.5006 11.0188C15.4129 11.0474 15.3367 11.1235 15.1847 11.2755L15.184 11.2762L11 15.4602Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditUser);
export default __webpack_public_path__ + "static/media/edit-user.75bc426dab92f99e07019b18c9842598.svg";
export { ForwardRef as ReactComponent };